import { SCRIPINFO } from "../actionTypes";

const initialState = {
    scripInfo: []

};

const scripInfoReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SCRIPINFO.GET_SCRIP_INFO_SUCCESS:
            return {
                ...state,
                scripInfo: actions.payload,
            };
        case SCRIPINFO.GET_SCRIP_INFO_FAILURE:
            return {
                ...state,
                scripInfo: actions.payload,
            };

        default:
            return state;
    }

};

export default scripInfoReducer;